
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/super-offers",
      function () {
        return require("private-next-pages/super-offers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/super-offers"])
      });
    }
  